/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdApplicationSharedPromoCodesRedeemPromoCodeCommand
 */
export interface FxIdApplicationSharedPromoCodesRedeemPromoCodeCommand {
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationSharedPromoCodesRedeemPromoCodeCommand
     */
    PromoCode: string;
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationSharedPromoCodesRedeemPromoCodeCommand
     */
    GameSystemName: string;
}

/**
 * Check if a given object implements the FxIdApplicationSharedPromoCodesRedeemPromoCodeCommand interface.
 */
export function instanceOfFxIdApplicationSharedPromoCodesRedeemPromoCodeCommand(value: object): value is FxIdApplicationSharedPromoCodesRedeemPromoCodeCommand {
    if (!('PromoCode' in value) || value['PromoCode'] === undefined) return false;
    if (!('GameSystemName' in value) || value['GameSystemName'] === undefined) return false;
    return true;
}

export function FxIdApplicationSharedPromoCodesRedeemPromoCodeCommandFromJSON(json: any): FxIdApplicationSharedPromoCodesRedeemPromoCodeCommand {
    return FxIdApplicationSharedPromoCodesRedeemPromoCodeCommandFromJSONTyped(json, false);
}

export function FxIdApplicationSharedPromoCodesRedeemPromoCodeCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationSharedPromoCodesRedeemPromoCodeCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'PromoCode': json['PromoCode'],
        'GameSystemName': json['GameSystemName'],
    };
}

export function FxIdApplicationSharedPromoCodesRedeemPromoCodeCommandToJSON(json: any): FxIdApplicationSharedPromoCodesRedeemPromoCodeCommand {
    return FxIdApplicationSharedPromoCodesRedeemPromoCodeCommandToJSONTyped(json, false);
}

export function FxIdApplicationSharedPromoCodesRedeemPromoCodeCommandToJSONTyped(value?: FxIdApplicationSharedPromoCodesRedeemPromoCodeCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'PromoCode': value['PromoCode'],
        'GameSystemName': value['GameSystemName'],
    };
}

